@import "../../theme/global";

lar-icon {
  fill: $text-color;
  stroke: $text-color;
}
.suninfo .sunrise > *, .suninfo .sunset > * {
  vertical-align: middle;
}
.suninfo {
  height: 2rem;
  width: 50%;
  margin: 0 auto 1rem auto;
  .sunrise, .sunset {
    display: inline-block;
    width: 50%;
    text-align: center;
  }
}

h4 {
  margin: 0.2rem 0 0 0;
}
.circle {
  background-color: $background-color-step-200 !important;
  border-radius: 50%;
  display: inline-block;
  padding: .5rem;
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
}
.circle lar-icon {
  display: block;
  width: 100%;
  height: 100%;
  color: $text-color !important;
}
lar-list-item {
  background-color: $background-color-step-100 !important;
  color: $text-color !important;
}